exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-container[data-v-31ea41b3]{min-width:0.9375rem;border-radius:0.03125rem;padding-left:0.05208rem;box-sizing:border-box;height:100%;display:flex;align-items:center}.item-container span[data-v-31ea41b3]{overflow:hidden;text-overflow:ellipsis}.el-icon-formatter[data-v-31ea41b3]{width:1em;height:1em;text-align:left;font-size:0.08333rem;color:#bfcbd9;margin-right:0.08333rem}\n", ""]);

// exports
